import usePortalQuery from 'src/Libs/api/hooks/use-portal-query'
import { getProtectedDownlodFile } from '../api'
import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { ProtectedFileModel } from '../models'
import { AuthFetchError } from '@e3dc-react/shell/Types'

export const useProtectedFile = (fileName: string): [ProtectedFileModel | undefined, boolean, AuthFetchError] => {
  const authFetch = useAuthFetchWithResponse()

  const { data, isLoading, error } = usePortalQuery({
    queryKey: ['downloads', 'protected-files', fileName],
    queryFn: () => getProtectedDownlodFile(fileName, authFetch),
    staleTime: Infinity,
    retry: false,
  })

  return [data ?? undefined, isLoading, error as AuthFetchError]
}
